import {alpha, createTheme} from '@mui/material/styles'
import type {PaletteMode} from '@mui/material'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    tablet: true
    xxl: true
    xxxl: true
  }
}

export const TIMER_FIT_MEDIA = '@media (min-width: 768px) and (min-height: 600px)'

const heading = {fontFamily: 'Georgia, "Times New Roman", serif', fontWeight: 700}
export const makeFeltTheme = (mode: PaletteMode) => createTheme({
  breakpoints: {values: {xs: 0, sm: 600, tablet: 768, md: 900, lg: 1200, xl: 1536, xxl: 1920, xxxl: 2560}},
  palette: {
    mode,
    secondary: {main: mode === 'dark' ? '#b5ceca' : '#526970'},
    warning: {main: mode === 'dark' ? '#ffda6a' : '#8a5800'},
    error: {main: mode === 'dark' ? '#ff8a80' : '#b3261e'},
    primary: {main: mode === 'dark' ? '#72e6c4' : '#007f60'},
    background: {default: mode === 'dark' ? '#0b1b16' : '#f3f7f5', paper: mode === 'dark' ? '#172c23' : '#ffffff'},
    text: {primary: mode === 'dark' ? '#f1f7f4' : '#082b22', secondary: mode === 'dark' ? '#b5ceca' : '#526970'},
    divider: mode === 'dark' ? '#3a5147' : '#dce5e1',
  },
  shape: {borderRadius: 12},
  typography: {fontFamily: 'Arial, sans-serif', h3: {...heading, fontSize: 'clamp(2rem, 4vw, 3rem)'}, h5: {...heading}, h6: {...heading}},
  components: {
    MuiCssBaseline: {styleOverrides: {'body:has(.firebase-emulator-warning)': {'--timer-footer-space': '4rem', '@media (min-width: 600px)': {'--timer-footer-space': '2rem'}}}},
    MuiPaper: {styleOverrides: {root: {backgroundImage: 'none', boxShadow: 'none', border: '1px solid', borderColor: mode === 'dark' ? '#3a5147' : '#dce5e1'}}},
    MuiAppBar: {styleOverrides: {root: {backgroundColor: mode === 'dark' ? '#11251d' : '#ffffff', color: mode === 'dark' ? '#f1f7f4' : '#082b22', boxShadow: 'none', borderBottom: '1px solid', borderColor: mode === 'dark' ? '#3a5147' : '#dce5e1'}}},
    MuiButton: {styleOverrides: {root: {textTransform: 'none'}, outlined: {borderColor: 'currentColor'}}},
    MuiButtonBase: {styleOverrides: {root: {'&.Mui-focusVisible': {outline: '2px solid', outlineOffset: 3}}}},
    MuiOutlinedInput: {styleOverrides: {root: {borderRadius: 6}, notchedOutline: {borderColor: mode === 'dark' ? '#738d81' : '#73877d'}}},
    MuiToggleButton: {styleOverrides: {root: ({theme}) => ({'&.Mui-selected': {color: theme.palette.primary.main, borderColor: theme.palette.primary.main, backgroundColor: alpha(theme.palette.primary.main, .15)}})}},
  },
})
